<template>
	<div
		class="w-full min-h-screen flex flex-col justify-start items-center bg-purple-900 bg-gradient-to-b from-gray-900 via-purple-800 to-purple-800">
		<div
			class="px-4 md:px-10 xl:px-32 w-full flex flex-col md:flex-row justify-between items-center mt-8">
			<!-- Title -->
			<h1
				class="text-4xl sm:text-5xl md:text-5xl text-center md:text-left font-bold text-gray-200">
				Black Books
			</h1>
			<div class="flex mt-6 md:mt-0 sm:gap-2 md:gap-4 items-center">
				<!-- Filter -->
				<div class="group inline-block">
					<button
						class="outline-none focus:outline-none px-3 py-1 text-white rounded-sm flex items-center min-w-32">
						<span class="pr-1 font-semibold flex-1">Filter</span>
						<svg
							class="fill-current h-4 w-4 transform group-hover:-rotate-180 transition duration-150 ease-in-out"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 20 20">
							<path
								d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
						</svg>
					</button>
					<ul
						class="border rounded-sm transform scale-0 group-hover:scale-100 absolute transition duration-150 ease-in-out origin-top min-w-32">
						<li class="rounded-sm bg-green-400 px-3 py-1 hover:bg-gray-200">
							Available
						</li>
						<li
							class="rounded-sm bg-white relative px-3 py-1 hover:bg-gray-200">
							<button
								class="w-full text-left flex items-center outline-none focus:outline-none">
								<span class="pr-1 flex-1">Instruments</span>
								<span class="mr-auto">
									<svg
										class="fill-current h-4 w-4 transition duration-150 ease-in-out"
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 20 20">
										<path
											d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
									</svg>
								</span>
							</button>
							<ul
								class="border rounded-sm absolute top-0 right-0 transition duration-150 ease-in-out origin-top-left min-w-32">
								<li class="px-3 py-1 hover:bg-gray-200 bg-green-400">
									MiniDrafter
								</li>
								<li class="px-3 py-1 hover:bg-gray-200 bg-green-400">
									Container
								</li>
								<li class="px-3 py-1 hover:bg-gray-200 bg-white">
									French Curve
								</li>
								<li class="px-3 py-1 hover:bg-gray-200 bg-white">Scales</li>
							</ul>
						</li>
					</ul>
				</div>
				<!-- SortBy -->
				<div class="group inline-block">
					<button
						class="outline-none focus:outline-none px-3 py-1 text-white rounded-sm flex items-center min-w-32">
						<span class="font-semibold flex-1">Sort By</span>
						<svg
							class="fill-current h-4 w-4 transform group-hover:-rotate-180 transition duration-150 ease-in-out"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 20 20">
							<path
								d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
						</svg>
					</button>
					<ul
						class="bg-white border rounded-sm transform scale-0 group-hover:scale-100 absolute transition duration-150 ease-in-out origin-top min-w-32">
						<li class="rounded-sm px-3 py-1 hover:bg-gray-100">Latest</li>
						<li class="rounded-sm px-3 py-1 hover:bg-gray-100">
							Most material
						</li>
					</ul>
				</div>
				<!-- Form -->
				<div>
					<button
						v-on:click="toggleModal()"
						class="px-4 py-4 h-1/2 bg-purple-900 rounded-xl text-xs uppercase font-bold text-white">
						Add More +
					</button>
					<div
						v-if="showModal"
						v-on:click="toggleModal()"
						class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
						<div class="relative my-6 mx-auto max-w-6xl">
							<!--content-->
							<div
								@click.stop="() => {}"
								class="px-8 py-8 w-80 border-0 rounded-lg shadow-lg relative flex flex-col bg-white outline-none focus:outline-none">
								<!--header-->
								<div
									class="pb-4 flex items-center justify-between border-b border-solid border-slate-200 rounded-t">
									<h3 class="text-xl font-semibold">Add BlackBook</h3>
									<button
										class="ml-auto bg-transparent border-0 text-black text-xl leading-none font-semibold outline-none focus:outline-none"
										v-on:click="toggleModal()">
										<span
											class="bg-transparent block outline-none focus:outline-none">
											X
										</span>
									</button>
								</div>
								<!--body-->
								<form
									class="space-y-4"
									@submit.prevent="handleSubmit()">
									<input
										v-model="title"
										class="w-full text-sm px-4 py-3 bg-gray-200 focus:bg-gray-100 border border-gray-200 rounded-lg focus:outline-none focus:border-purple-400"
										type="text"
										autocomplete="on"
										placeholder="Project Title" />
									<input
										v-model="report"
										class="w-full text-sm px-4 py-3 bg-gray-200 focus:bg-gray-100 border border-gray-200 rounded-lg focus:outline-none focus:border-purple-400"
										type="url"
										autocomplete="on"
										placeholder="Report URL" />
									<div>
										<h3
											class="mb-1 font-semibold text-gray-900 dark:text-white">
											Date of Publication
										</h3>
										<input
											v-model="date"
											value="date"
											class="w-full text-sm px-4 py-3 bg-gray-200 focus:bg-gray-100 border border-gray-200 rounded-lg focus:outline-none focus:border-purple-400"
											type="date"
											autocomplete="on" />
									</div>
									<div>
										<h3
											class="mb-1 font-semibold text-gray-900 dark:text-white">
											Project Type
										</h3>
										<ul
											class="w-full text-sm font-medium flex justify-between text-gray-900 bg-white rounded-lg border border-gray-200 dark:bg-gray-700 dark:border-gray-600 dark:text-white">
											<li
												class="w-full rounded-t-lg border-b border-gray-200 dark:border-gray-600">
												<div class="flex items-center pl-3">
													<input
														id="list-radio-license"
														type="radio"
														v-model="type"
														value="SW"
														name="list-radio"
														class="w-4 h-4 bg-gray-100 border-gray-300" />
													<label
														for="list-radio-license"
														class="py-3 ml-2 w-full text-sm font-medium text-gray-900 dark:text-gray-300">
														Software
													</label>
												</div>
											</li>
											<li
												class="w-full rounded-t-lg border-b border-gray-200 dark:border-gray-600">
												<div class="flex items-center justify-end px-3">
													<input
														id="list-radio-id"
														type="radio"
														v-model="type"
														value="HW"
														name="list-radio"
														class="w-4 h-4 bg-gray-100 border-gray-300" />
													<label
														for="list-radio-id"
														class="py-3 ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
														Hardware
													</label>
												</div>
											</li>
										</ul>
									</div>

									<div
										class="flex items-center justify-between border-t border-solid border-slate-200 rounded-b">
										<button
											class="text-purple-800 bg-transparent border border-solid border-purple-800 hover:bg-purple-800 hover:text-white active:bg-red-600 font-bold uppercase text-sm px-4 py-3 rounded outline-none focus:outline-none ease-linear transition-all duration-150"
											type="button"
											v-on:click="toggleModal()">
											Close
										</button>
										<button
											type="submit"
											class="flex justify-center bg-purple-800 hover:bg-purple-700 text-gray-100 p-3 rounded-lg tracking-wide font-semibold cursor-pointer transition ease-in duration-500">
											Submit
										</button>
									</div>
								</form>
							</div>
						</div>
					</div>
					<div
						v-if="showModal"
						class="opacity-25 fixed inset-0 z-40 bg-black"></div>
				</div>
			</div>
		</div>
		<div
			v-if="allData.length"
			class="px-4 md:px-10 xl:px-32 pt-12 pb-8 w-full flex flex-wrap justify-center gap-4 items-stretch justify-items-stretch">
			<BookCard
				v-for="item in allData"
				:key="item.title"
				:title="item.title"
				:date="item.date"
				:type="item.type"
				:report="item.report" />
		</div>
		<div v-else class="px-4 py-8 w-full flex flex-col items-center justify-center">
			<img class="w-96 h-96" src="@/assets/Empty-bro.png" alt="No items to display">
			<h2 class="text-lg text-white font-normal -mt-10">No items to display</h2>
		</div>
	</div>
</template>

<style scoped>
li > ul {
	transform: translatex(100%) scale(0);
}
li:hover > ul {
	transform: translatex(101%) scale(1);
}
li > button svg {
	transform: rotate(-90deg);
}
li:hover > button svg {
	transform: rotate(-270deg);
}
.group:hover .group-hover\:scale-100 {
	transform: scale(1);
}
.group:hover .group-hover\:-rotate-180 {
	transform: rotate(180deg);
}
.scale-0 {
	transform: scale(0);
}
.min-w-32 {
	min-width: 5rem;
}
</style>

<script>
import Vue from 'vue'
import axios from 'axios'
import BookCard from '@/components/Cards/BookCard.vue'

export default {
	name: 'BlackBooks',
	components: {
		BookCard
	},
	data() {
		return {
			title: '',
			type: '',
			date: new Date().toISOString().substring(0, 10),
			report: '',
			allData: [],
			showModal: false
		}
	},
	mounted() {
		this.loadData()
	},
	methods: {
		toggleModal: function () {
			this.showModal = !this.showModal
		},
		async loadData() {
			const res = await axios.get('api/blackbooks')
			this.allData = res.data
		},
		async handleSubmit() {
			const data = {
				title: this.title,
				projectType: this.type,
				report: this.report,
				publishedOn: this.date
			}
			const res = await axios.post('api/blackbook', data)
			this.loadData()
			this.toggleModal()
			Vue.$toast.info(res.data.message, { position: 'top' })
		}
	}
}
</script>
